const javascriptApplicableExpressions = {
    DISABLE_EXPRESSION : 'Disable Expression',

    REQUIRED_EXPRESSION : 'Required Expression'

};

angular.module('gw-um-j2js')
    .constant('javascriptApplicableExpressions', javascriptApplicableExpressions);